import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoItsForSection() {
  return <section className="py-14 md:py-24 px-5 md:px-6 bg-[#0a0e1a]" data-id="element-177">
      <div className="max-w-5xl mx-auto" data-id="element-178">
        <div className="grid md:grid-cols-2 gap-6 md:gap-12" data-id="element-179">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1
        }} className="bg-[#111827]/50 p-5 md:p-8 rounded-2xl border border-[#c9a96e]/20" data-id="element-180">
            <h3 className="text-xl md:text-2xl font-playfair text-[#f5f0e8] mb-5 md:mb-8 flex items-center" data-id="element-181">
              <span className="bg-[#c9a96e]/20 text-[#c9a96e] p-1.5 md:p-2 rounded-full mr-3 md:mr-4" data-id="element-182">
                <CheckIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-183" />
              </span>
              This is for you if:
            </h3>
            <ul className="space-y-3 md:space-y-4" data-id="element-184">
              {['you wake 3–5am multiple nights a week', 'you feel "wired but tired"', "you've tried basic sleep hygiene and it didn't touch the loop", 'you want something you can use tonight without buying a new lifestyle'].map((item, index) => <li key={index} className="flex items-start text-sm md:text-base text-[#e8e0d4]" data-id="element-185">
                  <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-[#c9a96e] mr-2 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-186" />
                  <span data-id="element-187">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="bg-[#111827]/30 p-5 md:p-8 rounded-2xl border border-[#ffffff]/5" data-id="element-188">
            <h3 className="text-xl md:text-2xl font-playfair text-[#8b8178] mb-5 md:mb-8 flex items-center" data-id="element-189">
              <span className="bg-[#8b8178]/20 text-[#8b8178] p-1.5 md:p-2 rounded-full mr-3 md:mr-4" data-id="element-190">
                <XIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-191" />
              </span>
              This is not for you if:
            </h3>
            <ul className="space-y-3 md:space-y-4" data-id="element-192">
              {['you suspect untreated sleep apnea or another medical condition that needs evaluation', "you're looking for a miracle claim or a one-pill promise"].map((item, index) => <li key={index} className="flex items-start text-sm md:text-base text-[#8b8178]" data-id="element-193">
                  <XIcon className="w-4 h-4 md:w-5 md:h-5 text-[#8b8178] mr-2 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-194" />
                  <span data-id="element-195">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}